export const area = [
  {
    label: '长安区',
    value: '长安区'
  },
  {
    label: '桥西区',
    value: '桥西区'
  },
  {
    label: '新华区',
    value: '新华区'
  },
  {
    label: '井陉矿区',
    value: '井陉矿区'
  },
  {
    label: '裕华区',
    value: '裕华区'
  },
  {
    label: '藁城区',
    value: '藁城区'
  },
  {
    label: '鹿泉区',
    value: '鹿泉区'
  },
  {
    label: '栾城区',
    value: '栾城区'
  },
  {
    label: '井陉县',
    value: '井陉县'
  },
  {
    label: '正定县',
    value: '正定县'
  },
  {
    label: '行唐县',
    value: '行唐县'
  },
  {
    label: '灵寿县',
    value: '灵寿县'
  },
  {
    label: '高邑县',
    value: '高邑县'
  },
  {
    label: '深泽县',
    value: '深泽县'
  },
  {
    label: '无极县',
    value: '无极县'
  },
  {
    label: '平山县',
    value: '平山县'
  },
  {
    label: '元氏县',
    value: '元氏县'
  },
  {
    label: '赵县',
    value: '赵县'
  },
  {
    label: '辛集市',
    value: '辛集市'
  },
  {
    label: '晋州市',
    value: '晋州市'
  },
  {
    label: '新乐市',
    value: '新乐市'
  }]
export const hourofday = [
  '00:00-01:00',
  '01:00-02:00',
  '02:00-03:00',
  '03:00-04:00',
  '04:00-05:00',
  '05:00-06:00',
  '06:00-07:00',
  '07:00-08:00',
  '08:00-09:00',
  '09:00-10:00',
  '10:00-11:00',
  '11:00-12:00',
  '12:00-13:00',
  '13:00-14:00',
  '14:00-15:00',
  '15:00-16:00',
  '16:00-17:00',
  '17:00-18:00',
  '18:00-19:00',
  '19:00-20:00',
  '20:00-21:00',
  '21:00-22:00',
  '22:00-23:00',
  '23:00-00:00']
